import React from 'react';
import MuiIconButton from '@material-ui/core/IconButton';

export default function IconButton(props) {
  const { children, ...rest } = props;

  return <MuiIconButton {...rest}>{children}</MuiIconButton>;
}
